var React = require('react');

function Pen (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19.264.293a1 1 0 00-1.415 0l-.872.872a3.001 3.001 0 00-3.415.587L2.955 12.358l5.657 5.657L19.22 7.408a2.999 2.999 0 00.586-3.414l.873-.873a1 1 0 000-1.414L19.264.293zm-4.268 8.51l-6.384 6.384-2.828-2.829 6.383-6.383 2.829 2.83v-.002zm1.818-1.818l.99-.99a1 1 0 000-1.415l-1.413-1.414a1 1 0 00-1.415 0l-.99.99 2.828 2.83z","key":0}),React.createElement("path",{"d":"M0 20.95l2.122-7.778 5.656 5.657L0 20.95z","key":1})]);
}

Pen.defaultProps = {"viewBox":"0 0 21 21"};

module.exports = Pen;

Pen.default = Pen;
